import { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsExporting from 'highcharts/modules/exporting';
import { Button, ButtonGroup, Center, Spinner } from '@chakra-ui/react';

HighchartsMore(Highcharts);
HighchartsExporting(Highcharts);

const AddressMarksByProjectChart = ({ holding, farming }) => {
	const [chartOptions, setChartOptions] = useState({});
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [filter, setFilter] = useState('lastWeek');

	useEffect(() => {
		const processHoldingData = () => {
			return Object.keys(holding).map(token => ({
				name: `${token}`,
				data: holding[token].points.map(point => [new Date(point.date).getTime(), point.points]),
				type: 'line',
			}));
		};

		const processFarmingData = () => {
			return Object.keys(farming).map(project => ({
				name: `${project}`,
				data: farming[project].marks.map(mark => [new Date(mark.date).getTime(), mark.marks]),
				type: 'line',
			}));
		};

		const fetchData = async () => {
			try {
				const holdingSeries = processHoldingData();
				const farmingSeries = processFarmingData();

				const combinedSeries = [...holdingSeries, ...farmingSeries];

				const styledSeries = combinedSeries.map(series => ({
					name: series.name,
					data: series.data,
					color: '#DD6B20',
					marker: {
						enabled: true,
						radius: 4,
						fillColor: '#ffffff',
						lineWidth: 2,
						lineColor: '#DD6B20',
					},
					tooltip: {
						pointFormat: 'Marks: <b>{point.y}</b>',
					},
					animation: {
						duration: 1000,
					},
				}));

				setChartOptions({
					chart: {
						type: 'line',
						height: 260,
						backgroundColor: 'transparent',
						zoomType: 'x',
					},
					title: {
						text: null,
						align: 'left',
					},
					xAxis: {
						type: 'datetime',
						labels: {
							style: {
								fontSize: '10px',
								color: '#666666',
							},
						},
					},
					yAxis: {
						title: {
							text: null,
							style: {
								color: '#333333',
								fontSize: '12px',
							},
						},
						labels: {
							formatter: function () {
								return `${Highcharts.numberFormat(this.value, 0)}`;
							},
							style: {
								fontSize: '10px',
								color: '#666666',
							},
						},
						gridLineWidth: 1,
						gridLineColor: '#e0e0e0',
					},
					tooltip: {
						formatter: function () {
							return `${this.series.name}, ${Highcharts.dateFormat('%A, %e %b %Y', this.x)} <br/>Marks: <b>${Highcharts.numberFormat(this.y, 2)}<b/>`;
						},
					},
					plotOptions: {
						line: {
							marker: {
								radius: 2,
							},
							lineWidth: 1,
							states: {
								hover: {
									lineWidth: 1,
								},
							},
						},
					},
					exporting: {
						enabled: false,
					},
					series: styledSeries,
					credits: {
						enabled: false,
					},
				});

				setLoading(false);
			} catch (error) {
				setError(error);
				setLoading(false);
			}
		};

		fetchData();
	}, [holding, farming]);

	if (loading) return <Center><Spinner /></Center>;
	if (error) return <p>Error fetching data: {error.message}</p>;

	return (
		<>
			<ButtonGroup size="xs" isAttached variant="outline" mb={4}>
				<Button variant={filter === 'all' ? 'custom' : 'outline'}
					onClick={() => setFilter('all')}>
					All Time
				</Button>
				<Button variant={filter === 'lastWeek' ? 'custom' : 'outline'}
					onClick={() => setFilter('lastWeek')}>
					Last Week
				</Button>
			</ButtonGroup>
			<div style={{ width: '100%' }}>
				<HighchartsReact highcharts={Highcharts} options={chartOptions} />
			</div>
		</>
	);
};

export default AddressMarksByProjectChart;
